<template>
  <div class="solution">
    <div class="solution_title">应用案例</div>
    <div class="solution_top">
      <ul>
        <li
          @mouseenter="showNum = 1"
          :style="
            showNum == 1
              ? 'border-bottom: 5px solid rgb(12, 50, 242);'
              : 'border-bottom: 5px solid rgba(235, 231, 231, 0.289);'
          "
        >
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/func/culture.png"
            alt=""
          />
          <span>沉浸式展览</span>
        </li>
        <li
          @mouseenter="showNum = 2"
          :style="
            showNum == 2
              ? 'border-bottom: 5px solid rgb(12, 50, 242);'
              : 'border-bottom: 5px solid rgba(235, 231, 231, 0.289);'
          "
        >
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/func/commer.png"
            alt=""
          />
          <span>数字化展厅</span>
        </li>
        <li
          @mouseenter="showNum = 3"
          :style="
            showNum == 3
              ? 'border-bottom: 5px solid rgb(12, 50, 242);'
              : 'border-bottom: 5px solid rgba(235, 231, 231, 0.289);'
          "
        >
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/func/show.png"
            alt=""
          />
          <span>教育科普</span>
        </li>
        <li
          @mouseenter="showNum = 4"
          :style="
            showNum == 4
              ? 'border-bottom: 5px solid rgb(12, 50, 242);'
              : 'border-bottom: 5px solid rgba(235, 231, 231, 0.289);'
          "
        >
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/func/num.png"
            alt=""
          />
          <span>数字化文旅</span>
        </li>
        <!--        <li-->
        <!--          @mouseenter="showNum = 5"-->
        <!--          :style="-->
        <!--            showNum == 5-->
        <!--              ? 'border-bottom: 5px solid rgb(12, 50, 242);'-->
        <!--              : 'border-bottom: 5px solid rgba(235, 231, 231, 0.289);'-->
        <!--          "-->
        <!--        >-->
        <!--          <img-->
        <!--            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/func/education.png"-->
        <!--            alt=""-->
        <!--          />-->
        <!--          <span>智慧教育</span>-->
        <!--        </li>-->
        <!--        <li-->
        <!--          @mouseenter="showNum = 6"-->
        <!--          :style="-->
        <!--            showNum == 6-->
        <!--              ? 'border-bottom: 5px solid rgb(12, 50, 242);'-->
        <!--              : 'border-bottom: 5px solid rgba(235, 231, 231, 0.289);'-->
        <!--          "-->
        <!--        >-->
        <!--          <img-->
        <!--            src="	https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/func/industry.png"-->
        <!--            alt=""-->
        <!--          />-->
        <!--          <span>智慧工业</span>-->
        <!--        </li>-->
      </ul>
    </div>
    <div class="solution_bottom">
      <div class="solution_bottom_hhh" v-show="showNum == 1">
        <div class="solution_bottom_left">
          <ul>
            <li>沉浸式展览</li>
            <li>
              运用投影映射、交互传感与空间音效技术，打造可交互主题叙事空间。
            </li>
            <li>
              <span>了解更多</span>
            </li>
          </ul>
        </div>
        <div class="solution_bottom_right">
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/index/culture.png"
            alt=""
          />
        </div>
      </div>
      <div class="solution_bottom_hhh" v-show="showNum == 2">
        <div class="solution_bottom_left">
          <ul>
            <li>数字化展厅</li>
            <li>
              通过数字沙盘、虚拟导览、数据可视化系统，构建企业品牌智慧展示中枢。
            </li>
            <li>
              <span>了解更多</span>
            </li>
          </ul>
        </div>
        <div class="solution_bottom_right">
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/index/sy.png"
            alt=""
          />
        </div>
      </div>
      <div class="solution_bottom_hhh" v-show="showNum == 3">
        <div class="solution_bottom_left">
          <ul>
            <li>教育科普</li>
            <li>
              研发 AR
              科普装置、互动投影系统、数字人讲解装置等前沿技术产品，打造深度探究式学习体验。
            </li>
            <li>
              <span>了解更多</span>
            </li>
          </ul>
        </div>
        <div class="solution_bottom_right">
          <img
            src="	https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/index/show.jpg"
            alt=""
          />
        </div>
      </div>
      <div class="solution_bottom_hhh" v-show="showNum == 4">
        <div class="solution_bottom_left">
          <ul>
            <li>数字营销</li>
            <li>
              从曝光引流、实地体验到消费传播，激活用户生活场景的潜在价值，于全流程中实现数据流转与留存。
            </li>
            <li>
              <span>了解更多</span>
            </li>
          </ul>
        </div>
        <div class="solution_bottom_right">
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/index/num.png"
            alt=""
          />
        </div>
      </div>
      <div class="solution_bottom_hhh" v-show="showNum == 5">
        <div class="solution_bottom_left">
          <ul>
            <li>数字化文旅</li>
            <li>
              以 AR
              文创、AI背诵装置等交互技术驱动游客深度参与，打造趣味化沉浸式文化互动新体验。
            </li>
            <li>
              <span>了解更多</span>
            </li>
          </ul>
        </div>
        <div class="solution_bottom_right">
          <img
            src="https://ar-scene-source.nosdn.127.net/b0d7b5d802318c4c93adf5a90f767466/index-v2/index/edu.jpg"
            alt=""
          />
        </div>
      </div>
      <div class="solution_bottom_hhh" v-show="showNum == 6">
        <div class="solution_bottom_left">
          <ul>
            <li>智慧工业</li>
            <li>
              结合AR空间标注、音视频通讯、AIoT等技术，针对多种工业场景，为企业提供高效快速的解决方案。
            </li>
            <li>
              <span>了解更多</span>
            </li>
          </ul>
        </div>
        <div class="solution_bottom_right">
          <img
            src="https://ar-scene-source.nosdn.127.net/b6cec1cb6e42f8ea3704f9d702682a91.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="zhanwei"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showNum: 1,
    };
  },
  mounted() {
    console.log("solution-mounted");
  },
  updated() {},
  destroyed() {},
  methods: {},
};
</script>

<style lang="less">
.solution {
  width: 100%;
  height: auto;
  background: #fafcff;

  &_title {
    font-size: 36px;
    font-weight: 400;
    color: #000;
    user-select: none;
  }

  &_top {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;

    ul {
      width: 60%;
      height: 10vw;
      display: flex;
      justify-content: center;
      align-items: center;

      li {
        width: 16%;
        height: 70%;
        border-bottom: 5px solid rgba(235, 231, 231, 0.289);
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        user-select: none;

        img {
          width: 30%;
          height: 30%;
        }

        span {
          margin-top: 20px;
          font-size: 20px;
        }

        &:hover {
          border-bottom: 5px solid rgb(12, 50, 242);
        }
      }
    }
  }

  &_bottom {
    &_hhh {
      width: 80%;
      height: 25vw;
      margin: auto;
      margin-top: 3vw;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &_left {
      width: 50%;
      height: 100%;

      ul {
        width: 100%;
        height: 100%;
        background: #f0f5fb;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: space-between;

        li {
          width: 100%;
          height: 30%;
          display: flex;
          align-items: center;
          text-align: left;
          box-sizing: border-box;
          padding-left: 4vw;

          &:nth-child(1) {
            font-size: 30px;
            align-items: end;
          }

          &:nth-child(2) {
            color: #797777;
            padding: 0 4vw;
          }

          &:nth-child(3) {
            span {
              background: rgb(11, 87, 217);
              padding: 13px;
              color: #fff;
              border-radius: 5px;
              cursor: pointer;

              &:hover {
                background: rgb(58, 115, 212);
              }
            }
          }
        }
      }
    }

    &_right {
      width: 50%;
      height: 100%;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

@media (max-width: 1920px) {
  .solution {
    &_top {
      ul {
        width: 90%;
        height: 14vw;
      }
    }
  }
}

@media (max-width: 550px) {
  .solution {
    display: none;
  }
}

.zhanwei {
  width: 100%;
  height: 5vw;
}
</style>
